import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import ImageComponent from "../../Common/ImageComponent";
import { ClosePopupHoc } from "../../../assets/images";

import { isUserIBlocked } from "../../../Helpers/Chat/BlockContact";

const ContactInfoProfileView = (props) => {
    const [ showProfileImg , setShowProfileImg] = React.useState(true)

    const handleProfileImgClose = (e) => {
        setShowProfileImg(false)
        props.handleContactInfoImg()
    } 

return (
    <React.Fragment>
        <div className="userprofile-popup">
            <div className="profile-image">
                <OutsideClickHandler
                    onOutsideClick={() => {}}>
                    {showProfileImg &&
                        <div className="Viewphoto-container">
                            <div className="Viewphoto-preview">
                                <ImageComponent
                                    chatType={'chat'}
                                    blocked={isUserIBlocked(props.chatJid)}
                                    temporary={false}
                                    imageToken={props.imageToken}
                                />
                                <i className="preview-close"
                                    onClick={(e) => handleProfileImgClose(e)}>
                                    <ClosePopupHoc viewBox="0 0 24 24"/>
                                </i>
                            </div>
                        </div>
                    }                    
                </OutsideClickHandler >
            </div>
        </div>
    </React.Fragment>
)};

export default ContactInfoProfileView;
